import { useEffect, useState } from "react";

declare global {
  interface Window {
    ReactNativeWebView?: { postMessage: (message: string) => void };
  }
}

/** True when the page is running inside the Zenvix React Native shell. */
export default function useIsWebView(): boolean {
  const [isWebView, setIsWebView] = useState(false);

  useEffect(() => {
    setIsWebView(
      typeof window !== "undefined" && window.ReactNativeWebView != null,
    );
  }, []);

  return isWebView;
}
